import React, { FC, use } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { KontoContext } from "../../../../../scripts/context/accountingData/KontoEntitiesProvider";
import { getTagDisplayName } from "@dms/modules/DocumentTableModule/helpers";
import { GQL } from "@binale-tech/shared";

export const CellRendererTag: FC<ICellRendererParams<GQL.IDocument>> = ({ data }) => {
    const { tagsAllMap } = use(KontoContext);

    return <div>{getTagDisplayName(data, tagsAllMap)}</div>;
};
